import * as React from "react";
const SvgFirefox = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#Firefox_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#Firefox_svg__b)",
  d: "M20.968 8.708c-.422-1.013-1.274-2.107-1.944-2.453.477.924.808 1.916.981 2.941l.003.017c-1.096-2.732-2.954-3.833-4.471-6.23a10 10 0 0 1-.228-.372 4 4 0 0 1-.107-.2 1.7 1.7 0 0 1-.145-.384.03.03 0 0 0-.021-.026h-.019l-.005.002-.006.004.004-.005c-2.434 1.426-3.26 4.063-3.336 5.382a4.85 4.85 0 0 0-2.667 1.028 3 3 0 0 0-.251-.19 4.5 4.5 0 0 1-.028-2.368 7.2 7.2 0 0 0-2.332 1.802h-.005c-.384-.487-.357-2.091-.335-2.426a1.8 1.8 0 0 0-.323.171 7 7 0 0 0-.948.812 8.5 8.5 0 0 0-.904 1.084 8.2 8.2 0 0 0-1.3 2.936l-.013.064c-.017.086-.083.512-.095.606q0 .01-.003.02a9.4 9.4 0 0 0-.157 1.337v.05c0 5.351 4.339 9.689 9.69 9.689a9.69 9.69 0 0 0 9.548-8.05q.024-.187.044-.374a9.97 9.97 0 0 0-.628-4.868zM9.8 16.292c.046.021.088.045.135.067l.006.004-.142-.07z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#Firefox_svg__c)",
  d: "M20.968 8.708c-.422-1.013-1.274-2.106-1.944-2.453.477.924.808 1.916.981 2.941l.002.01v.01c.916 2.478.417 4.999-.3 6.538-1.11 2.383-3.798 4.824-8.006 4.706-4.546-.129-8.55-3.502-9.298-7.92-.136-.697 0-1.05.068-1.617a7.2 7.2 0 0 0-.157 1.336v.05c0 5.35 4.338 9.69 9.69 9.69a9.69 9.69 0 0 0 9.549-8.05q.024-.187.044-.374a9.97 9.97 0 0 0-.628-4.868z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#Firefox_svg__d)",
  d: "M20.968 8.708c-.422-1.013-1.274-2.106-1.944-2.453.477.924.808 1.916.981 2.941l.002.01v.01c.916 2.478.417 4.999-.3 6.538-1.11 2.383-3.798 4.824-8.006 4.706-4.546-.129-8.55-3.502-9.298-7.92-.136-.697 0-1.05.068-1.617a7.2 7.2 0 0 0-.157 1.336v.05c0 5.35 4.338 9.69 9.69 9.69a9.69 9.69 0 0 0 9.549-8.05q.024-.187.044-.374a9.97 9.97 0 0 0-.628-4.868z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#Firefox_svg__e)",
  d: "m16.26 9.847.06.044a5.3 5.3 0 0 0-.9-1.174c-3.011-3.011-.79-6.53-.414-6.708l.004-.006c-2.434 1.426-3.26 4.064-3.336 5.382.113-.007.225-.016.34-.016a4.89 4.89 0 0 1 4.244 2.48z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#Firefox_svg__f)",
  d: "M12.02 10.448c-.017.242-.867 1.072-1.165 1.072-2.756 0-3.203 1.667-3.203 1.667.122 1.402 1.099 2.559 2.283 3.17q.08.041.163.079.14.061.285.117c.405.143.83.225 1.26.242 4.829.227 5.765-5.773 2.28-7.516.893-.155 1.819.204 2.337.567a4.89 4.89 0 0 0-4.245-2.48c-.115 0-.228.01-.34.017A4.85 4.85 0 0 0 9.008 8.41c.148.125.315.292.667.638.657.648 2.343 1.32 2.347 1.398z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#Firefox_svg__g)",
  d: "M12.02 10.448c-.017.242-.867 1.072-1.165 1.072-2.756 0-3.203 1.667-3.203 1.667.122 1.402 1.099 2.559 2.283 3.17q.08.041.163.079.14.061.285.117c.405.143.83.225 1.26.242 4.829.227 5.765-5.773 2.28-7.516.893-.155 1.819.204 2.337.567a4.89 4.89 0 0 0-4.245-2.48c-.115 0-.228.01-.34.017A4.85 4.85 0 0 0 9.008 8.41c.148.125.315.292.667.638.657.648 2.343 1.32 2.347 1.398z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#Firefox_svg__h)",
  d: "M8.555 8.09q.102.065.2.133a4.5 4.5 0 0 1-.027-2.368 7.2 7.2 0 0 0-2.332 1.802c.047 0 1.452-.026 2.16.433"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#Firefox_svg__i)",
  d: "M2.403 12.541c.748 4.418 4.752 7.792 9.298 7.92 4.207.12 6.896-2.323 8.006-4.706.717-1.54 1.217-4.06.302-6.539v-.01l-.001-.008.002.016c.344 2.245-.798 4.418-2.583 5.889l-.005.013c-3.477 2.83-6.804 1.708-7.477 1.248l-.141-.07c-2.028-.97-2.864-2.817-2.686-4.4a2.49 2.49 0 0 1-2.295-1.443s1.537-1.096 3.562-.144a4.83 4.83 0 0 0 3.638.144c-.003-.08-1.69-.75-2.346-1.398-.352-.346-.519-.514-.667-.638a3 3 0 0 0-.25-.19l-.2-.134C7.851 7.632 6.447 7.66 6.4 7.66h-.005c-.384-.487-.357-2.092-.335-2.427a1.8 1.8 0 0 0-.323.172 7 7 0 0 0-.948.811q-.497.505-.904 1.085a8.2 8.2 0 0 0-1.3 2.936c-.005.021-.35 1.526-.18 2.307z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#Firefox_svg__j)",
  fillOpacity: 0.8,
  d: "M15.42 8.717c.353.347.657.742.9 1.174q.076.056.145.12c2.196 2.023 1.046 4.887.96 5.09 1.785-1.47 2.926-3.644 2.584-5.888-1.097-2.731-2.955-3.832-4.472-6.23a10 10 0 0 1-.228-.37 4 4 0 0 1-.107-.2 1.7 1.7 0 0 1-.145-.384.03.03 0 0 0-.021-.027h-.019l-.005.003q-.003 0-.006.004c-.375.178-2.597 3.697.414 6.708"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#Firefox_svg__k)",
  d: "M16.466 10.01a2 2 0 0 0-.146-.12q-.03-.022-.06-.043c-.518-.364-1.444-.722-2.338-.566 3.485 1.742 2.55 7.742-2.28 7.516-.43-.018-.854-.1-1.26-.243a6 6 0 0 1-.285-.117q-.082-.037-.164-.078l.007.004c.673.459 4 1.583 7.477-1.249l.005-.012c.085-.204 1.237-3.067-.96-5.092z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#Firefox_svg__l)",
  d: "M7.653 13.186s.447-1.666 3.203-1.666c.298 0 1.15-.831 1.165-1.072a4.83 4.83 0 0 1-3.638-.143c-2.025-.953-3.562.143-3.562.143a2.49 2.49 0 0 0 2.295 1.444c-.18 1.584.658 3.431 2.685 4.399.046.021.088.045.135.067-1.183-.612-2.16-1.769-2.283-3.172"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#Firefox_svg__m)",
  d: "M20.968 8.708c-.422-1.013-1.274-2.107-1.944-2.453.477.924.808 1.916.981 2.941l.003.017c-1.096-2.732-2.954-3.833-4.471-6.23a10 10 0 0 1-.228-.372 4 4 0 0 1-.107-.2 1.7 1.7 0 0 1-.145-.384.03.03 0 0 0-.021-.026h-.019l-.005.002-.006.004.004-.005c-2.434 1.426-3.26 4.063-3.336 5.382.113-.007.225-.016.34-.016a4.89 4.89 0 0 1 4.244 2.479c-.517-.364-1.443-.723-2.337-.566 3.484 1.742 2.55 7.742-2.28 7.516-.43-.018-.854-.1-1.261-.243a6 6 0 0 1-.284-.117q-.082-.037-.164-.078l.006.004-.14-.07q.066.031.134.066c-1.183-.612-2.16-1.768-2.283-3.171 0 0 .447-1.666 3.203-1.666.298 0 1.15-.832 1.165-1.072-.004-.08-1.69-.75-2.347-1.398-.35-.347-.518-.514-.667-.638a3 3 0 0 0-.25-.19 4.5 4.5 0 0 1-.028-2.369 7.2 7.2 0 0 0-2.331 1.802h-.005c-.384-.487-.358-2.091-.335-2.426a1.8 1.8 0 0 0-.324.171 7 7 0 0 0-.947.812q-.497.504-.905 1.085a8.2 8.2 0 0 0-1.3 2.935q-.008.033-.012.065c-.018.085-.1.518-.112.611q-.112.672-.144 1.352v.05C2.31 17.662 6.65 22 12 22a9.69 9.69 0 0 0 9.548-8.05q.024-.187.044-.373a10 10 0 0 0-.628-4.869zm-.962.497v.01h.002v-.01z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "Firefox_svg__c",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(19.8754 0 0 20.2091 18.883 6.194)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.13,
  stopColor: "#FFBD4F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.28,
  stopColor: "#FF980E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.47,
  stopColor: "#FF3750"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "#EB0878"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.86,
  stopColor: "#E50080"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Firefox_svg__d",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(20.3716 0 0 20.2091 11.893 12.506)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.3,
  stopColor: "#960E18"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#B11927",
  stopOpacity: 0.74
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.43,
  stopColor: "#DB293D",
  stopOpacity: 0.34
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#F5334B",
  stopOpacity: 0.09
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.53,
  stopColor: "#FF3750",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Firefox_svg__e",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(6.48799 0 0 11.0182 14.404 1.26)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.13,
  stopColor: "#FFF44F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.53,
  stopColor: "#FF980E"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Firefox_svg__f",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(8.57755 0 0 9.40307 9.935 17.69)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#3A8EE6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67,
  stopColor: "#9059FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C139E6"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Firefox_svg__g",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(5.846 -99.67 122.44)scale(4.33606 5.03628)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.21,
  stopColor: "#9059FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6E008B",
  stopOpacity: 0.6
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Firefox_svg__h",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(6.83741 0 0 6.86639 12.151 3.417)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#FFE226"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#FF7139"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Firefox_svg__i",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(32.6143 0 0 27.3793 16.81 -1.322)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.11,
  stopColor: "#FFF44F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.46,
  stopColor: "#FF980E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.72,
  stopColor: "#FF3647"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#E31587"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Firefox_svg__k",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(18.7726 0 0 18.4465 10.63 5.607)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#FFF44F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.48,
  stopColor: "#FF980E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.66,
  stopColor: "#FF3647"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#E31587"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Firefox_svg__l",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(22.5598 0 0 20.1889 16.639 6.792)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.09,
  stopColor: "#FFF44F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.63,
  stopColor: "#FF980E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Firefox_svg__b",
  x1: 20.019,
  x2: 4.479,
  y1: 5.085,
  y2: 19.978,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.05,
  stopColor: "#FFF44F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.37,
  stopColor: "#FF980E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.53,
  stopColor: "#FF3647"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7,
  stopColor: "#E31587"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Firefox_svg__j",
  x1: 14.793,
  x2: 18.82,
  y1: -0.327,
  y2: 17.479,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF44F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3,
  stopColor: "#FF980E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.57,
  stopColor: "#FF3647"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.74,
  stopColor: "#E31587"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Firefox_svg__m",
  x1: 18.995,
  x2: 6.569,
  y1: 5.081,
  y2: 18.72,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.17,
  stopColor: "#FFF44F",
  stopOpacity: 0.8
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.678,
  stopColor: "#FFF44F",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "Firefox_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M2.31 2h19.38v20H2.31z"
}))));
export default SvgFirefox;
//# sourceMappingURL=Firefox.js.map